import React, { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { ProfileCategorySearch } from '../../components/ProfileCategories/ProfileCategorySearch';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { useNavigation } from '../../../common/navigation';

export const ProfileCategoriesView: React.FC = () => {
  const { t, tk } = useTranslation('administrationLng');

  const pok = usePokCore();
  const nav = useNavigation();

  const getData = useMemo(
    () =>
      ((pageSize, pageNumber, orderBy, orderDirection, filterText) =>
        pok.profileCategories.getAllByPortion(
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
        )) as GridGetterFunction,
    [pok.profileCategories],
  );

  const getCount = useMemo(
    () =>
      (filterText =>
        pok.profileCategories.getAllCount(filterText)) as GridCountFunction,
    [pok.profileCategories],
  );

  const handleAdd = () => {
    nav.profileCategoryAdd();
  };

  const handleClick = async (id: string) => {
    nav.profileCategoryEditor(id);
  };

  return (
    <Card className="main-card">
      <Card.Body className="m-3">
        <Card.Title className="pb-3">
          {t(tk.administration.profileCategories)}
        </Card.Title>
        <Button variant="outline-primary" onClick={handleAdd}>
          {t(tk.administration.profileCategoryNew)}
        </Button>
        <ProfileCategorySearch
          getData={getData}
          getCount={getCount}
          onRowClick={handleClick}
        />
      </Card.Body>
    </Card>
  );
};
